/**
 * Routes that may be reached without a leading hash (e.g. OAuth / email links).
 * Must stay in sync with React Router paths in App.tsx.
 */
export const HASH_ROUTER_PATHS_WITHOUT_PREFIX = [
  "/auth/callback",
  "/reset-password",
  "/forgot-password",
  "/verify-email-change",
] as const;

export const OAUTH_CALLBACK_PATH = "/auth/callback";

/** Fast lookup for bootstrapHashRouterFromPathname */
export const HASH_ROUTER_PATH_SET = new Set<string>(HASH_ROUTER_PATHS_WITHOUT_PREFIX);
